// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9.29434 22H22V18.1952L11.5196 13.4698L9.29434 22Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 16.0013V2H14.5117L12.0317 11.5068L22 16.0013Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.4448 2H2V22H7.2274L12.4448 2Z"}}]};

const CollageFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'collage-filled',
    ref,
    icon: element,
  },
));

CollageFilledIcon.displayName = 'CollageFilledIcon';

export default CollageFilledIcon;
